import React from 'react'
import Text from '../../../Text'
import styles from './styles.module.css'
import Cta from '../../../Cta'
import { Grow } from '@mui/material'
import { price } from '../../../../utils/formats'
import FeaturesList from '../../PricingTable/FeaturesList'

function PricingOffer({ show, title, subtitle, price, cta, isMostPopular, mostPopularText = 'BEST SELLER',
                        features }) {
  const includedFeatures = features.filter(f => f.isIncluded)
  const excludedFeatures = features.filter(f => !f.isIncluded)

  return (
    <Grow in={show} timeout={{ enter: 500 }} >
      <div className={isMostPopular ? `${styles.wrapper} ${styles.wrapperMostPopular}` : styles.wrapper}>
        <div className={isMostPopular ? `${styles.mostPopularTag} ${styles.mostPopularTagVisible}` : styles.mostPopularTag}>
          <Text type="h5">{mostPopularText.toUpperCase()}</Text>
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.priceWrapper}>
            <Text type="h5">{title.toUpperCase()}</Text>
            { renderPriceText(price, isMostPopular) }
          </div>
          <Text type="body-short-2">{subtitle}</Text>
          <FeaturesList features={includedFeatures}/>
          <FeaturesList features={excludedFeatures}/>
        </div>
        <div className={styles.ctaWrapper}>
          <Cta {...cta} dark primary={isMostPopular}/>
        </div>
      </div>
    </Grow>
  )
}

const renderPriceText = (p, isMostPopular) => {
  return (
    <div className={isMostPopular ? `${styles.priceText} ${styles.priceTextMostPopular}` : styles.priceText}>
      <Text type="h1">{ price(p.priceCents, p.currency) }</Text>
    </div>
  )
}

export default PricingOffer
